import { ApiResponse, RssSite, RssItem, RssSitePageData, RssFeedPageData, RssItemPageData } from '../types';

const getBaseResponse = async <T>(url: string): Promise<ApiResponse<T>> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status} StatusText: ${response.statusText}`);
  }
  return response.json();
};

export const api = {
  getHomepageItems: () => getBaseResponse<RssSite[]>('api/home/homepage'),
  getFeedItems: (feedId: number) => getBaseResponse<RssFeedPageData>(`api/feed/${feedId}`),
  getLatestItems: () => getBaseResponse<RssItem[]>('api/item/latest'),
  getSiteItems: (siteId: number) => getBaseResponse<RssSitePageData>(`api/site/${siteId}`),
  getItem: (itemId: number) => getBaseResponse<RssItemPageData>(`api/item/${itemId}`),
};
